var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotInsured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_insured",
    clipPath: "url(#clip0_1232_24074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.468 1.46374L13.1347 3.21374C13.3889 3.30903 13.6079 3.47964 13.7626 3.70278C13.9172 3.92591 14 4.19093 14 4.46241V8.03774C14 9.15202 13.6898 10.2443 13.104 11.1922C12.5182 12.1401 11.68 12.9061 10.6833 13.4044L8.44733 14.5217C8.30845 14.5912 8.15529 14.6274 8 14.6274C7.84471 14.6274 7.69155 14.5912 7.55267 14.5217L5.31667 13.4037C4.32003 12.9054 3.48185 12.1394 2.89605 11.1915C2.31025 10.2436 1.99998 9.15136 2 8.03707V4.46307C1.99983 4.19148 2.0826 3.92632 2.23725 3.70305C2.39189 3.47978 2.61102 3.30907 2.86533 3.21374L7.532 1.46374C7.83375 1.35063 8.16625 1.35063 8.468 1.46374ZM8 5.33374C7.83671 5.33376 7.67911 5.39371 7.55709 5.50222C7.43506 5.61072 7.35711 5.76024 7.338 5.92241L7.33333 6.00041V7.33374H6C5.83008 7.33393 5.66665 7.39899 5.54309 7.51564C5.41953 7.63228 5.34518 7.79171 5.33522 7.96134C5.32526 8.13096 5.38045 8.29799 5.48951 8.42829C5.59857 8.5586 5.75327 8.64234 5.922 8.66241L6 8.66707H7.33333V10.0004C7.33352 10.1703 7.39859 10.3338 7.51523 10.4573C7.63188 10.5809 7.7913 10.6552 7.96093 10.6652C8.13056 10.6751 8.29759 10.62 8.42789 10.5109C8.55819 10.4018 8.64193 10.2471 8.662 10.0784L8.66667 10.0004V8.66707H10C10.1699 8.66688 10.3334 8.60182 10.4569 8.48517C10.5805 8.36853 10.6548 8.2091 10.6648 8.03948C10.6747 7.86985 10.6196 7.70282 10.5105 7.57252C10.4014 7.44222 10.2467 7.35847 10.078 7.33841L10 7.33374H8.66667V6.00041C8.66667 5.82359 8.59643 5.65403 8.4714 5.529C8.34638 5.40398 8.17681 5.33374 8 5.33374Z",
    fill: "#FFA7A1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_24074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInsured);
export default __webpack_public_path__ + "static/media/not-insured.45bb417c5e54b74ab0aa9aa0051c48d4.svg";
export { ForwardRef as ReactComponent };